import {
  MenuButton,
  Avatar,
  MenuList,
  MenuGroup,
  Center,
  Text,
  MenuItem,
  Menu,
  useColorModeValue,
  Flex,
  Heading,
  AvatarBadge
} from '@chakra-ui/react'
import CustomTooltip from 'components/CustomTooltip'
import { useAuthContext } from 'context/AuthProvider'

import { UsersPermissionsUser } from 'generated/graphql'
import React from 'react'

import { VscSignOut } from 'react-icons/vsc'
import { useMediaQuery } from 'react-responsive'
import { useHistory } from 'react-router'

type ProfileButtonProps = {
  onLogout: () => void
  user: UsersPermissionsUser | undefined
}

const ProfileButton: React.FC<ProfileButtonProps> = ({ onLogout, user }) => {
  const history = useHistory()
  const themeGray = useColorModeValue('gray.100', 'gray.700')

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 40em)' })
  const { isAuthenticated } = useAuthContext()
  const [username, agentNumber] = user?.username?.split('-') || ['', '']
  return (
    <Menu placement={isTabletOrMobile ? 'top-end' : 'bottom-end'}>
      <CustomTooltip label={isAuthenticated ? 'Profile' : 'Login'}>
        {isAuthenticated ? (
          <MenuButton
            p={1}
            mx={1}
            borderRadius="50%"
            _hover={{ bg: themeGray }}
            _expanded={{ bg: themeGray }}
            _focus={{ boxShadow: 'outline' }}
          >
            <Center>
              <Avatar src={user?.profilePicture?.url} size="xs" name={user?.username}>
                <AvatarBadge boxSize="1em" bg="green.500" />
              </Avatar>
            </Center>
          </MenuButton>
        ) : (
          <Center onClick={() => history.push('/login')}>
            <Avatar src={user?.profilePicture?.url} size="xs" name={user?.username}>
              <AvatarBadge boxSize="1em" bg="green.500" />
            </Avatar>
          </Center>
        )}
      </CustomTooltip>
      <MenuList textAlign="left" rounded="2xl" overflow="hidden" zIndex={45} fontSize="xs" p={0}>
        {isAuthenticated ? (
          <>
            <MenuGroup>
              <MenuItem onClick={() => history.push('/auth/profile')}>
                <Center py={2}>
                  <Avatar src={user?.profilePicture?.url} size="sm" name={user?.username} mr={4}>
                    <AvatarBadge boxSize="1em" bg="green.500" />
                  </Avatar>
                  <Flex direction="column">
                    <Heading as="h4" fontSize="md">
                      {username}{' '}
                    </Heading>
                    {agentNumber && (
                      <Text fontSize="x-small" color="gray.500">
                        {agentNumber}
                      </Text>
                    )}
                    <Text fontSize="x-small" fontWeight="semibold" mt={2} color="gray.500">
                      {user?.email}
                    </Text>
                  </Flex>
                </Center>
              </MenuItem>
            </MenuGroup>

            <MenuItem icon={<VscSignOut />} color="red.500" onClick={onLogout}>
              Se déconnecter
            </MenuItem>
          </>
        ) : (
          <></>
        )}
      </MenuList>
    </Menu>
  )
}

export default ProfileButton
